import Vue from 'vue'
import Router from 'vue-router'

import Login from './views/Login/Login.vue'
import Dashboard from './views/Dashboard/Dashboard.vue'
import FoodTracking from './views/FoodTracking/FoodTracking.vue'
import AddFood from './views/FoodTracking/AddFood.vue'
import AddCustomRecipe from './views/FoodTracking/AddCustomRecipe.vue'
import WeightTracking from './views/WeightTracking/WeightTracking.vue'
import WaterTracking from './views/WaterTracking/WaterTracking.vue'
import MeasurementTracking from './views/MeasurementsTracking/MeasurementsTracking.vue'
import Exercise from './views/Exercise/Exercise.vue'
import GymExercise from './views/Exercise/GymExercise.vue'
import Welcome from './views/Welcome/Welcome.vue'
import ShoppingList from './views/ShoppingList/ShoppingList.vue'
import Profile from './views/Profile/Profile.vue'
import Upgrade from './views/Profile/Upgrade.vue'
import CheckPayment from './views/Profile/CheckPayment.vue'
import Menopause from './views/Diet/Menopause.vue'
import Keto from './views/Diet/Keto.vue'
import StartDietPlan from './views/Diet/StartDietPlan.vue'
import TermsAndConditions from './views/TermsAndConditions/TermsAndConditions.vue'
import PersonalTraining from './views/Exercise/PersonalTraining.vue'
import ConirmRegistration from './views/Login/ConfirmRegistration.vue'

Vue.use(Router)

export default new Router({
  mode:'hash',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/confirm-email/:code',
      name: 'confirm-registration',
      component: ConirmRegistration
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: Welcome
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/t&c',
      name: 'termsandconditions',
      component: TermsAndConditions
    },
    {
      path: '/food-tracker',
      name: 'food-tracker',
      component: FoodTracking
    },
    {
      path: '/add-food/:meal',
      name: 'add-food',
      component: AddFood
    },
    {
      path: '/water-tracker',
      name: 'water-tracker',
      component: WaterTracking
    },
    {
      path: '/weight-tracker',
      name: 'weight-tracker',
      component: WeightTracking
    },
    {
      path: '/measurement-tracker',
      name: 'measurement-tracker',
      component: MeasurementTracking
    },
    {
      path: '/weight-tracker/track',
      name: 'weight-tracker-track',
      component: WeightTracking
    },
    {
      path: '/exercise',
      name: 'exercise',
      component: Exercise
    },
    {
      path: '/exercise/training',
      name: 'exercise-training',
      component: PersonalTraining
    },
    {
      path: '/exercise/gym-exercise',
      name: 'gym-exercise',
      component: GymExercise
    },
    {
      path: '/shoppinglist',
      name: 'shoppinglist',
      component: ShoppingList
    },
    {
      path: '/customrecipe',
      name: 'customrecipe',
      component: AddCustomRecipe
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/profile/upgrade',
      name: 'upgrade',
      component: Upgrade
    },
    {
      path: '/confirm-payment',
      name: 'confirmpayment',
      component: CheckPayment
    },
    {
      path: '/menopause',
      name: 'menopause',
      component: Menopause
    },
    {  
      path: '/keto',
      name: 'keto',
      component: Keto

    },
    {
      path: '/StartDietPlan',
      name: 'StartDietPlan',
      component: StartDietPlan

    }
  ]
})


// WEBPACK FOOTER //
// ./src/router.js